import { render, staticRenderFns } from "./MinistriesPrayer.vue?vue&type=template&id=c25ad954&"
import script from "./MinistriesPrayer.vue?vue&type=script&lang=js&"
export * from "./MinistriesPrayer.vue?vue&type=script&lang=js&"
import style0 from "./MinistriesPrayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports